// extracted by mini-css-extract-plugin
export default {"tupacGrid":"yl-z","tupacHeader":"zl-z","tupacHeader2":"Al-z","tupacMenu":"Bl-z","tupacMenu2":"Cl-z","tupacMain":"Dl-z","tupacMain2":"El-z"};